import React from 'react';
import { Box, Typography } from '@mui/material';
import { AppTheme } from '../../../../theme/App.theme';
import './PanchangSection.css';

const PanchangSection = ({ 
  title, 
  icon, 
  children, 
  backgroundColor = AppTheme.PRIMARY_WHITE,
  headerColor = AppTheme.PRIMARY_COLOR,
  iconColor = AppTheme.PRIMARY_WHITE,
  textColor = AppTheme.PRIMARY_WHITE,
  className = "",
  style = {}
}) => {
  return (
    <Box className={`panchang-section ${className}`} style={style}>
      <Box 
        className="panchang-section-header"
        sx={{
          backgroundColor: headerColor,
          color: textColor,
          display: 'flex',
          alignItems: 'center',
          padding: { xs: '12px 16px', sm: '14px 20px', md: '16px 24px' },
          borderRadius: { xs: '8px 8px 0 0', sm: '10px 10px 0 0', md: '12px 12px 0 0' },
          minHeight: { xs: '48px', sm: '52px', md: '56px' }
        }}
      >
        {icon && (
          <Box 
            className="panchang-section-icon"
            sx={{
              marginRight: { xs: '8px', sm: '10px', md: '12px' },
              display: 'flex',
              alignItems: 'center',
              fontSize: { xs: '18px', sm: '20px', md: '22px' }
            }}
          >
            {icon}
          </Box>
        )}
        <Typography 
          variant="h6" 
          sx={{
            fontWeight: 600,
            fontSize: { xs: '16px', sm: '18px', md: '20px' },
            flex: 1
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box 
        className="panchang-section-content"
        sx={{
          backgroundColor: backgroundColor,
          padding: "16px",
          borderRadius: { xs: '0 0 8px 8px', sm: '0 0 10px 10px', md: '0 0 12px 12px' },
          minHeight: '100px'
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default PanchangSection;
